import {
  FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_DESER,
  FULLY_PAID_SECURITIES_LENDING_REQUEST_DESER,
  FullyPaidSecuritiesLendingEligibility,
  FullyPaidSecuritiesLendingRequest,
} from "../../tastyworks/fully-paid-securities-lending-request"
import type HttpClient from "../../tastyworks/http"
import type { SingleResponse } from "../../tastyworks/response"

export class FullyPaidSecuritiesLendingRequestService {
  private readonly requestClient: HttpClient
  private readonly eligibilityClient: HttpClient

  constructor(accountNumberClient: HttpClient) {
    this.requestClient = accountNumberClient.nested(
      "fully-paid-securities-lending-requests"
    )
    this.eligibilityClient = accountNumberClient.nested(
      "fully-paid-securities-lending-request-eligibility"
    )
  }

  readonly showLatest = async (
    accountNumber: string
  ): Promise<SingleResponse<FullyPaidSecuritiesLendingRequest>> =>
    this.requestClient.show(
      new FullyPaidSecuritiesLendingRequest(),
      FULLY_PAID_SECURITIES_LENDING_REQUEST_DESER.update,
      "latest",
      { accountNumber }
    )

  readonly create = async (
    fullyPaidSecuritiesLendingRequest: FullyPaidSecuritiesLendingRequest
  ): Promise<SingleResponse<FullyPaidSecuritiesLendingRequest>> =>
    this.requestClient.create(
      fullyPaidSecuritiesLendingRequest,
      FULLY_PAID_SECURITIES_LENDING_REQUEST_DESER.serialize,
      FULLY_PAID_SECURITIES_LENDING_REQUEST_DESER.update,
      "",
      { accountNumber: fullyPaidSecuritiesLendingRequest.accountNumber }
    )

  readonly show = async (
    accountNumber: string,
    id: number
  ): Promise<SingleResponse<FullyPaidSecuritiesLendingRequest>> => {
    const fullyPaidSecuritiesLendingRequest =
      new FullyPaidSecuritiesLendingRequest()
    return this.requestClient.show(
      fullyPaidSecuritiesLendingRequest,
      FULLY_PAID_SECURITIES_LENDING_REQUEST_DESER.update,
      ":id",
      { accountNumber, id }
    )
  }

  readonly showEligibility = async (
    accountNumber: string
  ): Promise<SingleResponse<FullyPaidSecuritiesLendingEligibility>> =>
    this.eligibilityClient.show(
      new FullyPaidSecuritiesLendingEligibility(),
      FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_DESER.update,
      "",
      { accountNumber }
    )
}
